// redux/importReseller/Slice.ts

import { createSlice } from '@reduxjs/toolkit';
import { REDUCER_NAME, IImportResellerState } from './Types';
import { getImportResellerList } from './thunkAction';

const initialState: IImportResellerState = {
  isLoading: false,
  list: [],
  error: null,
};

const importResellerSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    clearImportResellerState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getImportResellerList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      }).addCase(getImportResellerList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload?.data ?? [];
      }).addCase(getImportResellerList.rejected, (state, action) => {
        state.isLoading = false;
        // @ts-expect-error
        state.error = action.payload ?? {
          message: 'Failed to fetch import reseller list',
        };
      });
  },
});

export const { clearImportResellerState } = importResellerSlice.actions;
export default importResellerSlice.reducer;
